import { Printer } from "lucide-react";
import { track } from "@/lib/analytics";
import { cn } from "@/lib/utils";

/**
 * Print the page (or save it as a PDF from the print dialog). The printer glyph stays:
 * on this one button it says what the button does faster than the words.
 *
 * `outline` is the site's secondary button; `primary` is for the page whose whole point
 * is the printout. The visible label is the accessible name, so what a voice-control
 * user reads off the screen is what they say.
 */
export function PrintButton({
  page,
  label = "Print or save as PDF",
  variant = "outline",
  className,
}: {
  page: string;
  label?: string;
  variant?: "outline" | "primary";
  className?: string;
}) {
  const onClick = () => {
    track("print_action_plan", { page });
    if (typeof window !== "undefined") window.print();
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "no-print inline-flex min-h-11 items-center gap-2 rounded-sm px-5 py-3 text-sm font-semibold transition-colors",
        variant === "primary"
          ? "bg-primary text-primary-foreground hover:bg-primary-dark"
          : "border border-foreground/30 text-foreground hover:border-foreground",
        className,
      )}
    >
      <Printer aria-hidden className="h-4 w-4" />
      {label}
    </button>
  );
}
